import type { Action } from 'redux';
import type { BasketTableAnswerItem } from '/index';

export interface FormState {
  currentQuestionId: string | null;
  editingItemId: BasketTableAnswerItem['itemId'] | null;
  editingItemKey: string | null;
}

interface EditingItemIdSetAction extends Action {
  type: 'EDITING_ITEM_ID_SET';
  itemId: BasketTableAnswerItem['itemId'];
  itemKey: string;
}

interface CurrentQuestionAction extends Action {
  type: 'CURRENT_QUESTION';
  question: string;
}

interface SetApplicationActiveFulfilledAction extends Action {
  type: 'SET_APPLICATION_ACTIVE_FULFILLED';
}

type FormAction = EditingItemIdSetAction | CurrentQuestionAction | SetApplicationActiveFulfilledAction;

const defaultState: FormState = {
  currentQuestionId: null,
  editingItemId: null,
  editingItemKey: null,
};

function reducer(state: FormState = defaultState, action: FormAction): FormState {
  switch (action.type) {
    case 'EDITING_ITEM_ID_SET': {
      return {
        ...state,
        editingItemId: action.itemId,
        editingItemKey: action.itemKey === '' ? null : action.itemKey,
      };
    }
    case 'CURRENT_QUESTION': {
      return {
        ...state,
        currentQuestionId: action.question,
      };
    }
    case 'SET_APPLICATION_ACTIVE_FULFILLED': {
      return {
        ...defaultState,
      };
    }
    default:
      return state;
  }
}

export default reducer;
